<template>
  <div>
    <form @submit.prevent="setUpMarketingSettings" class="text-left">
      <div class="form-group">
        <b-form-radio-group v-model="marketingSettings">
          <b-form-radio class="w-50 mr-0" v-for="(i, index) in industries.map(x => {return {text: x.description, value: x.id}})" :value="i.value" :key="index">{{i.text === 'Other' ? $pgettext('fem', 'Other') : i.text}}</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="text-center">
        <b-button variant="primary" type="submit" :disabled="marketingSettings.length === 0 || sending">
          <b-spinner small v-if="sending"></b-spinner>
          <translate>Update Company profile</translate>
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MarketingSettingsForm',
  data() {
    return {
      industries: [],
      marketingSettings: '',
      sending: false
    }
  },
  mounted() {
    const params = {
      filter_groups: [
        {
          filters: [
            ['type', 'eq', 'industry']
          ]
        }
      ]
    }
    this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', {params: params})
      .then(response => {
        this.industries = response.body.data
      })
  },
  methods: {
    setUpMarketingSettings() {
      this.sending = true
      let payload = {
        company_id: this.$store.getters.profile.company.id,
        marketing_catalog_id: this.marketingSettings
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/marketing-settings', payload)
        .then(response => {
          window.location.reload()
        })
    }
  }
}
</script>
